import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.99967 6.8928L10.7497 4.22222M4.99967 9.1046L10.7497 11.7751M12.6663 5.33203C11.5617 5.33203 10.6663 4.4366 10.6663 3.33203C10.6663 2.22746 11.5617 1.33203 12.6663 1.33203C13.7709 1.33203 14.6663 2.22746 14.6663 3.33203C14.6663 4.4366 13.7709 5.33203 12.6663 5.33203ZM3.33301 9.99873C2.22844 9.99873 1.33301 9.10327 1.33301 7.99873C1.33301 6.89413 2.22844 5.9987 3.33301 5.9987C4.43757 5.9987 5.33301 6.89413 5.33301 7.99873C5.33301 9.10327 4.43757 9.99873 3.33301 9.99873ZM12.6663 14.6654C11.5617 14.6654 10.6663 13.7699 10.6663 12.6654C10.6663 11.5608 11.5617 10.6654 12.6663 10.6654C13.7709 10.6654 14.6663 11.5608 14.6663 12.6654C14.6663 13.7699 13.7709 14.6654 12.6663 14.6654Z",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShareIcon;
